import styled, { css } from 'styled-components'

import { isDesktop } from 'utils/device'

export const PieTimerWrapper = styled.div`
    position: absolute;
    height: 35px;
    width: 35px;

    ${() =>
        !isDesktop &&
        css`
            width: 50px;
            height: 50px;
        `}
`
